export const extractPageNumberFromUrl = (
  value: number | string | null | undefined,
  prev: boolean = false
): number | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    try {
      const url = new URL(value);
      const pageParam = url.searchParams.get('page');
      return pageParam ? parseInt(pageParam, 10) : prev ? 1 : null;
    } catch {
      return null;
    }
  }
  return null;
};
